import 'reactflow/dist/style.css'
import { Select, SelectItem } from '@nextui-org/react'
import useChartStore from '../../store/chart/useChartStore'
import { useGroupStore } from '../../store/group/useGroupStore'
import { useShallow } from 'zustand/react/shallow'

export const SelectGroup = () => {
  const { groupId, setGroup } = useChartStore(
    useShallow((state) => ({
      groupId: state.groupId,
      setGroup: state.setGroup,
    })),
  )
  const groups = useGroupStore((state) => state.groups)

  const onSelectionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedGroupId = event.target.value
    if (selectedGroupId) {
      const selectedGroup = groups.find((g) => g.id === selectedGroupId)
      if (selectedGroup) {
        setGroup(selectedGroup.id, selectedGroup.name)
      }
    }
  }

  return (
    <div>
      <Select
        label="Select Group"
        variant="bordered"
        radius="sm"
        size="md"
        placeholder="Group Name"
        classNames={{
          trigger: 'w-full border border-tdpldarkgrey border-opacity-60',
          label: 'font-bold text-[1rem]',
          base: 'pt-[1rem] pb-[1rem]',
          value: 'text-tdpldark',
        }}
        disallowEmptySelection={true}
        labelPlacement="outside"
        defaultSelectedKeys={groupId ? [groupId] : undefined}
        onChange={onSelectionChange}
        selectorIcon={<p />}
      >
        {groups.map((group) => (
          <SelectItem
            key={group.id}
            value={group.name}
            data-testid={`group-option-${group.id}`}
            data-group-id={group.id}
            data-group-name={group.name}
          >
            {group.name}
          </SelectItem>
        ))}
      </Select>
    </div>
  )
}
